const defaultEmptyData = {};

export const getInitialState = (
  // biome-ignore lint/style/useDefaultParameterLast: ignore
  emptyData = defaultEmptyData,
  // biome-ignore lint/style/useDefaultParameterLast: ignore
  loadingProp = 'loading',
  // biome-ignore lint/style/useDefaultParameterLast: ignore
  loadedProp = 'loaded',
  optionalProps
) => ({
  data: emptyData,
  [loadingProp]: false,
  [loadedProp]: false,
  saving: false,
  error: '',
  ...optionalProps
});

export const createRoutineReducers = (routine, loadingProp = 'loading', loadedProp = 'loaded') => ({
  [routine.REQUESTED]: (state) => state,
  [routine.PENDING]: (state) => ({ ...state, [loadingProp]: true }),
  [routine.CANCELLED]: (state) => ({
    ...state,
    [loadingProp]: false,
    saving: false
  }),
  [routine.REJECTED]: (state, { payload }) => ({
    ...state,
    [loadingProp]: false,
    saving: false,
    error: payload
  }),
  [routine.FULFILLED]: (state, { payload }) => ({
    ...state,
    [loadingProp]: false,
    [loadedProp]: true,
    saving: false,
    error: '',
    data: payload
  })
});
